import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./LinkCustom.scss";

export const LinkCustom = ({
    className,
    children,
    target,
    autoWidth,
    textOverflow,
    title,
    href,
    ...restProps
}) => {

    const classes = classNames(
        "go-to-href",
        { "go-to-href--auto-width": autoWidth },
        { "go-to-href--text-overflow": textOverflow },
        className
    );

    return (
        <a
            className={classes}
            title={title || href}
            href={href}
            target={target}
            rel="noopener noreferrer"
            {...restProps}
        >
            { children }
        </a>
    );
};

LinkCustom.defaultProps = {
    textOverflow: true,
    target: "_blank",
    href: "/"
};

LinkCustom.propTypes = {
    textOverflow: PropTypes.bool,
    target: PropTypes.string,
    maxWidth: PropTypes.string,
    title: PropTypes.string,
    style: PropTypes.object,
    href: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func
    ]).isRequired,
    children: PropTypes.any
};
